export default class MyStorage {
    jwt_token = "jwt_token";
    cart_count = "cart_count"
    cart_amount = "cart_amount"
    contactIDFrasers = "contactIDFrasers"
    emailFrasers = "emailFrasers"
    authenticationFrasers = "authenticationFrasers"
    PhoneNumber = "PhoneNumber"
    SsoCode = "SsoCode"
    name = "name"
    loggedIn = "loggedIn"
    UserId = "UserId"
    access_token = "access_token"
    cart_id = "cart_id"
    searchHistory = "search_history"
    promoResponse = 'promo_response'
    setItem(key, value) {
        localStorage.setItem(key, "".concat(value));
    }
    getItem(key) {
        return localStorage.getItem(key)
    }
    removeItem(key) {
        return localStorage.deleteItem(key, {})
    }
    clearStorage() {
        return localStorage.clear();
    }
    setCartCount(cart_count) {
        return this.setItem(this.cart_count, cart_count)
    }
    getCartCount() {
        return this.getItem(this.cart_count)
    }
    setCartAmount(cart_amount) {
        return this.setItem(this.cart_amount, cart_amount)
    }
    getCartAmount() {
        return this.getItem(this.cart_amount)
    }
    setContactIDFrasers(contactIDFrasers) {
        return this.setItem(this.contactIDFrasers, contactIDFrasers)
    }
    getContactIDFrasers() {
        return this.getItem(this.contactIDFrasers)
    }
    setEmailFrasers(emailFrasers) {
        return this.setItem(this.emailFrasers, emailFrasers)
    }
    getEmailFrasers() {
        return this.getItem(this.emailFrasers)
    }
    setauthenticationFrasers(authenticationFrasers) {
        return this.setItem(this.authenticationFrasers, authenticationFrasers)
    }
    getauthenticationFrasers() {
        return this.getItem(this.authenticationFrasers)
    }
    setPhoneNumber(PhoneNumber) {
        return this.setItem(this.PhoneNumber, PhoneNumber)
    }
    getPhoneNumber() {
        return this.getItem(this.PhoneNumber)
    }
    setName(name) {
        return this.setItem(this.name, name)
    }
    getName() {
        return this.getItem(this.name)
    }
    setSsoCode(SsoCode) {
        return this.setItem(this.SsoCode, SsoCode)
    }
    getSsoCode() {
        return this.getItem(this.SsoCode)
    }
    setloggedIn(loggedIn) {
        return this.setItem(this.loggedIn, loggedIn)
    }
    getloggedIn() {
        return this.getItem(this.loggedIn)
    }
    setUserId(UserId) {
        return this.setItem(this.UserId, UserId)
    }
    getUserId() {
        return this.getItem(this.UserId)
    }
    setaccess_token(access_token) {
        return this.setItem(this.access_token, access_token)
    }
    getaccess_token() {
        return this.getItem(this.access_token)
    }
    setCartID(cart_id) {
        return this.setItem(this.cart_id, cart_id)
    }
    getCartID() {
        return this.getItem(this.cart_id)
    }
    setSearchHistory(searchHistory) {
        return this.setItem(this.searchHistory, searchHistory)
    }
    getSearchHistory() {
        return this.getItem(this.searchHistory)
    }
    setPromoResponse(response) {
        console.log("Setting Promo Code Application Response in My Storage ===>>>>>", response, typeof response)
        return this.setItem(this.promoResponse, response)
    }
    getPromoResponse() {
        return this.getItem(this.promoResponse)
    }
}